<p-panel id="additionalSettingsPanel">
    <ng-template #header>
        <h3 class="font-semibold" tabindex="-1" i18n="@@appointment-filter-settings.additionalSettings">
            Additional Settings
        </h3>
    </ng-template>
    <div>
        @if(coreLibService.getSecurityInformation().userProfile != null){
        <div class="flex align-items-center filterCheckbox">
            <div>
                <p-checkbox id="filterMyEvents" inputId="filterMyEvents" [binary]="true"
                    [(ngModel)]="filterMyEvents"></p-checkbox>
            </div>

            <label for="filterMyEvents" i18n="@@appointment-filter-settings.additionalSettings.showOwnSignUps"
                class="text-sm ml-2 filterCheckboxLabel">
                Show only your own sign-ups.
            </label>
        </div>

        <div class="flex align-items-center mt-2 filterCheckbox">
            <div>
                <p-checkbox id="filterOnlyWithFreeSignUpSlots" inputId="filterOnlyWithFreeSignUpSlots" [binary]="true"
                    [(ngModel)]="filterOnlyWithFreeSignUpSlots"></p-checkbox>
            </div>

            <label for="filterOnlyWithFreeSignUpSlots"
                i18n="@@appointment-filter-settings.additionalSettings.filterOnlyWithFreeSignUpSlots"
                class="text-sm ml-2 filterCheckboxLabel">
                Show only events with available spaces.
            </label>
        </div>
        }

        <div class="flex align-items-center mt-2 filterCheckbox">
            <div>
                <p-checkbox id="dontFilterUpcomingEvents" inputId="dontFilterUpcomingEvents" [binary]="true"
                    [(ngModel)]="dontFilterUpcomingEvents"></p-checkbox>
            </div>

            <label for="dontFilterUpcomingEvents"
                i18n="@@appointment-filter-settings.additionalSettings.dontFilterUpcomingEvents"
                class="text-sm ml-2 filterCheckboxLabel">
                Show past events
            </label>
        </div>

        <div class="flex align-items-center mt-2 filterCheckbox">
            <div>
                <p-checkbox id="onlyShowFavorites" inputId="onlyShowFavorites" [binary]="true"
                    [(ngModel)]="onlyShowFavorites"></p-checkbox>
            </div>

            <label for="onlyShowFavorites" i18n="@@appointment-filter-settings.additionalSettings.onlyShowFavorites"
                class="text-sm ml-2 filterCheckboxLabel">
                Only show Favorites
            </label>
        </div>
    </div>
</p-panel>


<p-panel styleClass="mt-3" id="calendarFilterPanel">
        <ng-template #header>
        <h3 class="font-semibold" i18n="@@appointment-filter-settings.calendars">
            Calendars
        </h3>
    </ng-template>
    <div>

        <div i18n="@@appointment-filter-settings.calendar-description" class="text-sm mb-2 calendarText">
            Please select calendars to show.
        </div>

        <label class="sr-only" i18n="@@appointment-management-filter.calendar.label" id="calendarFilterLabel" inputId="calendarFilterLabel">Filtered calendars</label>
        <p-multiSelect [options]="calendars" optionLabel="title" optionValue="id" [(ngModel)]="selectedCalendarIds"
            inputId="calendarFilterMultiselect" scrollHeight="250px" selectedItemsLabel="{0} ausgewählte Kalender"
            i18n-emptyMessage="@@appointment-management-filter.locations.noCalendars" emptyMessage="No calendars filtered" [maxSelectedLabels]="1"
            [style]="{ minWidth: '100%', maxWidth: '100%' }" [filter]="true" [showClear]="true"
            ariaLabelledBy="calendarFilterLabel" (onChange)="onSelectionChange()">
            <ng-template let-calendar pTemplate="item">
                <div class="flex align-items-center">
                    <div class="h-2rem w-2rem swatch calendarSelectColor" [style.background-color]="calendar.color">
                    </div>
                    <div class="ml-2 calendarSelectLabel">{{ calendar.title }}</div>
                </div>
            </ng-template>
            <ng-template let-calendar pTemplate="selectedItem">
                <div class="flex align-items-center">
                    <div class="h-1rem w-1rem swatch calendarSelectColor" [style.background-color]="calendar.color">
                    </div>
                    <div class="ml-1">{{ calendar.title }}</div>
                </div>
            </ng-template>
        </p-multiSelect>

    </div>
</p-panel>


<p-panel styleClass="mt-3" id="locationsFilterPanel">
    <ng-template #header>
        <h3 class="font-semibold" i18n="@@appointment-filter-settings.locations">
            Locations
        </h3>
    </ng-template>
    <div>
        <div i18n="@@appointment-filter-settings.location-description" class="text-sm mb-2 locationText">
            Please select locations to narrow down your search. If no location is picked, no filter will be applied.
        </div>

        <label class="sr-only" i18n="@@appointment-management-filter.locations.label" id="locationFilterLabel" inputId="locationFilterLabel">Filtered locations</label>
        <p-multiSelect [options]="locations" optionLabel="title" [(ngModel)]="selectedLocationIds" optionValue="id"
            inputId="locationFilterMultiselect" scrollHeight="250px" selectedItemsLabel="{0} ausgewählte Orte"
            i18n-emptyMessage="@@appointment-management-filter.locations.noLoctaions" [maxSelectedLabels]="1"
            emptyMessage="No locations filtered" [style]="{'minWidth':'100%', 'maxWidth': '100%'}" [filter]="true"
            ariaLabelledBy="locationFilterLabel" [showClear]="true">
            <ng-template let-item #item>
                <div class="white-space-normal">{{item.title}}</div>
            </ng-template>
        </p-multiSelect>

    </div>
</p-panel>

<ng-container *ngIf="isFilterActive">
    <div class="mt-3"></div>
    <div class="flex justify-content-start mb-5 resetButton">
        <p-checkbox id="resetFilter" [binary]="true" [(ngModel)]="resetFilter"></p-checkbox>
        <label class="ml-2" for="resetFilter" i18n="@@appointment-filter-settings.button.reset">Reset filter</label>
    </div>

</ng-container>

<div class="mt-3"></div>

<div class="flex justify-content-between buttonBox">
    <p-button type="button" severity="secondary" class="cancelButton" (click)="this.ref.close(null)" label="Cancel"
        i18n-label="@@appointment-filter-settings.button.cancel"></p-button>
    <p-button type="button" severity="secondary" class="saveButton" (click)="onSave()" label="Apply"
        i18n-label="@@appointment-filter-settings.button.apply"></p-button>
</div>